import { render, staticRenderFns } from "./FeatureCardVideo.vue?vue&type=template&id=50daa502&"
import script from "./FeatureCardVideo.vue?vue&type=script&lang=js&"
export * from "./FeatureCardVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports